import React from "react"
import { useHistory } from "react-router-dom"

import {
	Edit as EditIcon,
	BarChart as BarChartIcon,
	FileCopyOutlined as FileCopyOutlinedIcon
} from "@material-ui/icons"
import { Grid } from "@material-ui/core"
import { MoreOptionsMenu, Notification } from "@/components"
import { usePermissionStateStore } from "@/store/PermissionState"
import { PERMISSION_DENIED_MESSAGE } from "@/components/PermissionGate/BasePermissionGate"
import { mountTrackableLinkMetricsPagePath } from "@/utils/trackableLinks"

import useStyles from "@/pages/Admin/TrackableLinks/ActionsDropdown/styles"
import copy from "copy-to-clipboard"

type OptionKey = "details" | "edit" | "copyLink" | "howToConfigLink"

type ActionsDropdownProps = {
	copyLinkUrl: string
	trackableLinkId: number
	hiddenOptions?: OptionKey[]
	fromDetailsPage?: boolean
}

const ActionsDropdown: React.FC<ActionsDropdownProps> = (props) => {
	const { copyLinkUrl, trackableLinkId, hiddenOptions, fromDetailsPage } = props
	const history = useHistory()
	const { checkPermission } = usePermissionStateStore()

	const classes = useStyles()
	const linkToRedirectToMetrics = mountTrackableLinkMetricsPagePath(trackableLinkId?.toString())

	const handleToRedirectTrackableLinkMetrics = () => {
		history.push(linkToRedirectToMetrics)
	}

	const handleToRedirectEditTrackableLinkPage = () => {
		const linkToEditPage = new URL(`/admin/conversion/tools/trackable-links/${trackableLinkId}/edit`, window.location.origin)

		// Check if the user is coming from the metrics page
		// If so, and the user clicks EDIT, we'll append a query param to update the breadcrumb dynamically on the edit page.
		if (fromDetailsPage) {
			linkToEditPage.searchParams.set("from", "details")
		}

		history.push(linkToEditPage.pathname + linkToEditPage.search)
	}

	const copyHandler = () => {
		copy(copyLinkUrl)
		Notification.success({ message: "Link copiado com sucesso!" })
	}

	return (
		<Grid container>
			<Grid item justifyContent="center" alignItems="center" className={classes.item}>
				<MoreOptionsMenu
					iconSize="small"
					options={[
						{
							title: "Ver métricas",
							icon: <BarChartIcon />,
							showIcon: true,
							hideOption: hiddenOptions?.includes("details"),
							onClick: handleToRedirectTrackableLinkMetrics
						},
						{
							title: "Copiar link",
							icon: <FileCopyOutlinedIcon />,
							showIcon: true,
							hideOption: hiddenOptions?.includes("copyLink"),
							onClick: copyHandler
						},
						{
							title: "Editar",
							icon: <EditIcon />,
							showIcon: true,
							hideOption: hiddenOptions?.includes("edit"),
							disabled: !checkPermission("trackable-link", "update"),
							disabledTooltip: PERMISSION_DENIED_MESSAGE,
							onClick: handleToRedirectEditTrackableLinkPage
						}
					]}
				/>
			</Grid>
		</Grid>
	)
}

export default ActionsDropdown
